import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { VSL } from './components/VSL';
import { Problem } from './components/Problem';
import { System } from './components/System';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { CtaFinal } from './components/CtaFinal';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-primary text-white font-sans selection:bg-accent selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <VSL data-id="element-5" />
        <Problem data-id="element-6" />
        <System data-id="element-7" />
        <About data-id="element-8" />
        <FAQ data-id="element-9" />
        <CtaFinal data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}